module.exports = __webpack_public_path__ + "static/media/bg-body.5d56a57f.jpg";